import type { FC } from 'react';

import { DateValue, useTimeLeft } from '@wwe-portal/ui/lib/hooks';

import { IcoMoonIcon } from '@wwe-portal/ui/components/icons/icomoon';
import { cn } from '@wwe-portal/ui/lib/lib';

export interface TimeCountDownProps {
  endDate: DateValue;
  className?: string;
  endTimeString?: string;
}
export const TimeCountDown: FC<TimeCountDownProps> = ({
  endDate,
  className,
  endTimeString,
}) => {
  const { getTimeText } = useTimeLeft(endDate);
  const getText = () => {
    const timeText = getTimeText(' ');
    if (timeText === '' && endTimeString) return endTimeString;

    return timeText;
  };

  return (
    <div className={cn('flex items-center', className)}>
      <IcoMoonIcon iconName="timer" className={'mb-[2px] mr-[1px] size-4'} />
      {getText()}
    </div>
  );
};
